module.exports = __webpack_public_path__ + "static/media/1012647.1da72cbf.jpg";